import { useEffect, useRef, useState } from "react";
import MapComponent from "../../../components/MapComponent";
import Page from "../../../components/Page/Page";
import { Button, Modal, Select, Form, Col, message } from "antd";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import { getAllMarketers, getMarketerLoaction } from "../../../API/Map/marketerLocation"; 
import PersianDatePicker from "../../../components/PersianDatePicker";

import Classes from "./index.module.css";

const ErrorModal = Modal.error;
const InfoModal = Modal.info;

const Maketerlocation = () => {
  const mapRef = useRef(null);
  const [marketerLocation, setMarketerLocation] = useState([]);
  const [marketerList, setMarketerList] = useState([]);
  const [selectedMarketer, setSelectedMarketer] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [opneModal, setModalOpen] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  const rDate = useRef(null);
  const markersRef = useRef([]); // store markers


  useEffect(() => {
    getAllMarketers().then(i=>{
        if(i.success){
            setMarketerList(i.data)
        }else{
            message.error("مشکلی هنگام دریافت اطلاعات بره وجود آمد",3000)
        }
    })
  }, []);

  function okHandler() {
    clearMap();
    setLoadingButton(true);
    
console.log("sent data",{
    datelocation: rDate.current,
    codeVisit: selectedMarketer
})
    getMarketerLoaction({
        datelocation: rDate.current,
        codeVisit: selectedMarketer
    })
      .then((i) => {
        if (i.success) {
            if(i.data.length){
                const bounds = new nmp_mapboxgl.LngLatBounds();
                let coordinate=[];
              i.data.map((i) => {
                const marker=new nmp_mapboxgl.Marker({ color: "#30E3CA", scale: 0.5 })
                
                  .setPopup(
                    new nmp_mapboxgl.Popup({ offset: 25 }).setText(i.time)
                  )
                  .setLngLat([i.lng, i.lat])
                  .addTo(mapRef.current);
                  bounds.extend(marker.getLngLat());
                  coordinate=[...coordinate,[i.lng, i.lat]];
                  markersRef.current.push(marker);
                });
                
                
                // Draw the polyline between markers
                if (coordinate.length > 1) {
                  mapRef.current.addLayer({
                    id: "route",
                    type: "line",
                    source: {
                      type: "geojson",
                      data: {
                        type: "Feature",
                        properties: {},
                        geometry: {
                          type: "LineString",
                          coordinates: coordinate,
                        },
                      },
                    },
                    layout: {
                      "line-join": "round",
                      "line-cap": "round",
                    },
                    paint: {
                      "line-color": "#ff0000",
                      "line-width": 3,
                    },
                  });
                }
                
                mapRef.current.fitBounds(bounds);
            }
        } else {
          message.error(i.message);
        }
      })
      .finally(() => {
        setLoadingButton(false);
        setModalOpen(false)
      })
      .catch((e) => {
        message.error("مشکلی هنگام انجام عملیات رخ داد"+ e);
      });
  }

  function clearMap() {
  // remove markers
  markersRef.current.forEach(m => m.remove());
  markersRef.current = [];

  // remove route layer & source if they exist
  if (mapRef.current.getLayer("route")) {
    mapRef.current.removeLayer("route");
  }
  if (mapRef.current.getSource("route")) {
    mapRef.current.removeSource("route");
  }
}

  return (
    <>
    <Modal
        open={opneModal}
        footer={[
          <Button
            key="submit"
            onClick={okHandler}
            loading={loadingButton}
            type="primary"
          >
            تایید
          </Button>,
          <Button
            key="cancel"
            disabled={loadingButton}
            onClick={() => {
              setModalOpen(false);
            }}
          >
            لغو
          </Button>,
        ]}
      >
        <Form>
         
            <Col lg={24} md={24} sm={24}>
              <Form.Item label="تاریخ" labelAlign="right">
                <PersianDatePicker ref={rDate} />
              </Form.Item>
            </Col>
            <Col lg={24} md={24} sm={24}>
              <Form.Item label="بازاریاب" labelAlign="right">
               <Select onChange={setSelectedMarketer}>
                {marketerList.map(i=>(<Select.Option value={i.code}>
                    {i.name}
                </Select.Option>))}
               </Select>
              </Form.Item>
            </Col>
            
          
        </Form>
      </Modal>
    <Page>
      <MapComponent
        ref={mapRef}
        buttonLoading={buttonLoading}
        action={()=>{setModalOpen(true)}}
      />
    </Page>
    </>
  );
};

export default Maketerlocation;
